import React, { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import { LuX } from "react-icons/lu";

const ImageShowModal = ({
  isOpen,
  toggle,
  imageSrc,
  className = "",
  style,
  alt = "Full Preview",
  closeButton = true,
}) => {
  const [aspectRatio, setAspectRatio] = useState(null);

  useEffect(() => {
    if (!imageSrc) {
      setAspectRatio(null);
      return;
    }
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      if (img.naturalWidth && img.naturalHeight) {
        setAspectRatio(img.naturalWidth / img.naturalHeight);
      }
    };
  }, [imageSrc]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      className={className}
      style={style}
      contentClassName="bg-transparent border-0 shadow-none"
    >
      <div className="d-flex justify-content-center align-items-center w-100">
        <div
          className="agenda-image-preview-wrapper"
          style={
            aspectRatio
              ? {
                  aspectRatio: `${aspectRatio}`,
                  width: `min(88vw, calc(85vh * ${aspectRatio}))`,
                }
              : undefined
          }
        >
          {closeButton && toggle && (
            <button
              type="button"
              className="agenda-image-preview-close-btn"
              onClick={toggle}
              aria-label="Close image preview"
            >
              <LuX size={20} />
            </button>
          )}
          <img
            src={imageSrc}
            alt={alt}
            className="agenda-image-preview-img"
            onLoad={(e) => {
              if (e.target.naturalWidth && e.target.naturalHeight) {
                setAspectRatio(e.target.naturalWidth / e.target.naturalHeight);
              }
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ImageShowModal;
